import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import { I18nProvider } from '@/lib/i18n';
import Landing from "@/pages/Landing";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import LegalLayout from "@/components/site/LegalLayout";
import CookieBanner from "@/components/site/CookieBanner";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import CallButton from "@/components/site/CallButton";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route element={<LegalLayout />}>
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
            </Route>
          </Routes>
          <Toaster position="bottom-right" theme="light" />
          <CookieBanner />
          <WhatsAppButton />
          <CallButton />
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
